import React from 'react';
import { LoadingContainer } from 'app/components/LoadingContainer';
import { lazyLoad } from 'utils/loadable';
// Luôn điều hướng vào detailPage; mode được quyết định sau khi fetch detail.
export const ReservationHistoryDetail = lazyLoad(
  () => import('./detailPage'),
  module => module.ReservationHistoryDetailPage,
  { fallback: <LoadingContainer loading /> },
);

